var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogomarkPurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 110,
  height: 167.746,
  viewBox: "0 0 110 167.746"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 167.746h110V0H0Z",
  "data-name": "Path 34"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  "data-name": "Group 46"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 44"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "m3.772 150.462 27.794 16.137a8.48 8.48 0 0 0 8.523 0l65.744-38.172a8.4 8.4 0 0 0 4.166-7.26V87.753a8.35 8.35 0 0 0-4.146-7.219L72.907 61.407 35.83 82.939l37.077 21.536-69.135 40.141a3.383 3.383 0 0 0 0 5.843",
  "data-name": "Path 32"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 45"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "m4.223 108.828 32.866 19.078V41.778L74.17 63.31l32.058-18.612a3.383 3.383 0 0 0 0-5.843l-65-37.739a8.25 8.25 0 0 0-8.283 0L4.158 17.829A8.37 8.37 0 0 0 0 25.073v76.4a8.5 8.5 0 0 0 4.223 7.354",
  "data-name": "Path 33"
})))));
export default SvgLogomarkPurple;